var _excluded = ["property"];
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { BedIcon, BathIcon, HouseIcon, HouseSizeIcon, SalesIcon, SizeFloorOutlineIcon, GarageIcon, CarportIcon, EerIcon, ParkingIcon, EnsuiteIcon } from '@domain-group/fe-co-icon';
import { ListingType, PropertyType } from '@domain-group/fe-allhomes-library';
import AllhomesKeyDetails from './allhomes-key-details';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment PropertyKeyDetails on Property {\n    listing {\n      type\n    }\n    features {\n      propertyType\n      bedrooms\n      parking {\n        other\n        garages\n        carports\n      }\n      bathrooms {\n        bathrooms\n        ensuites\n      }\n    }\n    address {\n      nbnDetails {\n        technology {\n          description\n          abbreviation\n        }\n      }\n      cadastralParcel {\n        legalDescription\n      }\n    }\n    derived {\n      keyDetails {\n        label\n        value\n        link\n        note\n        type\n        approximate\n      }\n    }\n  }\n"])));
var graphQLToProps = function graphQLToProps() {
  var _features$bathrooms, _features$bathrooms2, _features$bathrooms3, _features$bathrooms4, _features$parking, _features$parking2, _features$parking3, _features$parking4, _features$parking5, _features$parking6, _address$cadastralPar;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listing = _ref.listing,
    listing = _ref$listing === void 0 ? {} : _ref$listing,
    features = _ref.features,
    address = _ref.address,
    _ref$derived = _ref.derived,
    derived = _ref$derived === void 0 ? {} : _ref$derived;
  var bedrooms = listing.type === ListingType.SHARE_RESIDENTIAL.name ? listing.roomsAvailable : features.bedrooms;
  var keyDetails = [(features === null || features === void 0 ? void 0 : features.bedrooms) > 0 ? {
    type: 'simple',
    label: 'Bedrooms',
    value: bedrooms,
    icon: BedIcon
  } : null, (features === null || features === void 0 ? void 0 : (_features$bathrooms = features.bathrooms) === null || _features$bathrooms === void 0 ? void 0 : _features$bathrooms.bathrooms) > 0 ? {
    type: 'simple',
    label: 'Bathrooms',
    value: features === null || features === void 0 ? void 0 : (_features$bathrooms2 = features.bathrooms) === null || _features$bathrooms2 === void 0 ? void 0 : _features$bathrooms2.bathrooms,
    icon: BathIcon
  } : null, (features === null || features === void 0 ? void 0 : (_features$bathrooms3 = features.bathrooms) === null || _features$bathrooms3 === void 0 ? void 0 : _features$bathrooms3.ensuites) > 0 ? {
    type: 'simple',
    label: 'Ensuite',
    value: features === null || features === void 0 ? void 0 : (_features$bathrooms4 = features.bathrooms) === null || _features$bathrooms4 === void 0 ? void 0 : _features$bathrooms4.ensuites,
    icon: EnsuiteIcon
  } : null, (features === null || features === void 0 ? void 0 : (_features$parking = features.parking) === null || _features$parking === void 0 ? void 0 : _features$parking.other) > 0 ? {
    type: 'simple',
    label: 'Parking',
    value: features === null || features === void 0 ? void 0 : (_features$parking2 = features.parking) === null || _features$parking2 === void 0 ? void 0 : _features$parking2.other,
    icon: ParkingIcon
  } : null, (features === null || features === void 0 ? void 0 : (_features$parking3 = features.parking) === null || _features$parking3 === void 0 ? void 0 : _features$parking3.garages) > 0 ? {
    type: 'simple',
    label: 'Garage Spaces',
    value: features === null || features === void 0 ? void 0 : (_features$parking4 = features.parking) === null || _features$parking4 === void 0 ? void 0 : _features$parking4.garages,
    icon: GarageIcon
  } : null, (features === null || features === void 0 ? void 0 : (_features$parking5 = features.parking) === null || _features$parking5 === void 0 ? void 0 : _features$parking5.carports) > 0 ? {
    type: 'simple',
    label: 'Carport spaces',
    value: features === null || features === void 0 ? void 0 : (_features$parking6 = features.parking) === null || _features$parking6 === void 0 ? void 0 : _features$parking6.carports,
    icon: CarportIcon
  } : null,
  // exclude PROPERTY prpertyType
  features !== null && features !== void 0 && features.propertyType && (features === null || features === void 0 ? void 0 : features.propertyType) !== PropertyType.PROPERTY.label ? {
    type: 'simple',
    label: 'Property type',
    value: PropertyType[features === null || features === void 0 ? void 0 : features.propertyType].label,
    icon: HouseIcon
  } : null].filter(Boolean);

  // some of the ones in key details section are of dervied values
  var keyDetailsIcons = {
    'Block Size': HouseSizeIcon,
    EER: EerIcon,
    'House Size': SizeFloorOutlineIcon,
    'Unimproved Value': SalesIcon
  };
  var KEY_DETAIL_LABELS = Object.keys(keyDetailsIcons);
  keyDetails.push(...derived.keyDetails.filter(item => KEY_DETAIL_LABELS.includes(item.label)).map(item => _objectSpread(_objectSpread({}, item), {}, {
    icon: keyDetailsIcons[item.label]
  })));
  var keyDetailLabels = keyDetails.map(item => item.label.toLowerCase());
  var otherDetails = derived.keyDetails.filter(item => !keyDetailLabels.includes(item.label.toLowerCase()));
  if (address !== null && address !== void 0 && (_address$cadastralPar = address.cadastralParcel) !== null && _address$cadastralPar !== void 0 && _address$cadastralPar.legalDescription) {
    otherDetails.push({
      label: "Legal description",
      value: address.cadastralParcel.legalDescription,
      type: 'simple'
    });
  }
  if (address.nbnDetails) {
    otherDetails.push({
      label: "nbn\xAE availability",
      value: "nbn\xAE ".concat(address.nbnDetails.technology.description, " (").concat(address.nbnDetails.technology.abbreviation, ")"),
      type: 'simple'
    });
  }
  return {
    keyDetails,
    otherDetails
  };
};
var AllhomesKeyDetailsGraphQL = _ref2 => {
  var property = _ref2.property,
    props = _objectWithoutProperties(_ref2, _excluded);
  return ___EmotionJSX(AllhomesKeyDetails, _extends({}, graphQLToProps(property), props));
};
AllhomesKeyDetailsGraphQL.fragment = fragment;
AllhomesKeyDetailsGraphQL.propTypes = {
  property: PropTypes.shape({
    derived: PropTypes.shape({
      keyDetails: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
        link: PropTypes.string,
        note: PropTypes.string,
        type: PropTypes.string
      }))
    })
  })
};
AllhomesKeyDetailsGraphQL.defaultProps = {
  property: {}
};
export default AllhomesKeyDetailsGraphQL;